import { render, staticRenderFns } from "./Form_Detail.vue?vue&type=template&id=f65ea5f4&scoped=true"
import script from "./Form_Detail.vue?vue&type=script&lang=js"
export * from "./Form_Detail.vue?vue&type=script&lang=js"
import style0 from "./Form_Detail.vue?vue&type=style&index=0&id=f65ea5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65ea5f4",
  null
  
)

export default component.exports